import { Injectable } from '@angular/core';
import { DataCompare } from './data-compare.interface';
import { Observable, BehaviorSubject } from 'rxjs';
import { FieldTableDto } from '@tj/tj-dmp-lib-api';

@Injectable({
  providedIn: 'root'
})
export class CompareService {

  dataObs: BehaviorSubject<DataCompare[]> =  new BehaviorSubject([]); 
  countObs: BehaviorSubject<number> =  new BehaviorSubject(0); 
  colsObs: BehaviorSubject<FieldTableDto[]> =  new BehaviorSubject([]); 
  fullObs:BehaviorSubject<boolean> =  new BehaviorSubject(false); 
  limit: BehaviorSubject<number> =  new BehaviorSubject(4); 

  constructor() { }
  init(){
    this.update([]);
  }

  toogleCompare(id: string, data: any): boolean{
    if(this.include(id)){
      this.removeCompare(id);
      return false;
    } else {
      return this.addCompare(id, data);
    }
  }
  addCompare(id: string, data: any): boolean{
    let datas = this.dataObs.value;
    datas.push({
      id: id,
      data: data
    });
    return this.update(datas);
  }
  removeCompare(id: string){
    let datas = this.dataObs.value;
    const index = datas.findIndex(item => item.id == id);
    if (index > -1) {
      datas.splice(index, 1);
    }
    this.update(datas);
  }

  include(id: string){
    const index = this.dataObs.value.findIndex(item => item.id == id);
    if (index > -1) {
      return true;
    } else {
      return false;
    }
  }

  private update(datas: DataCompare[]): boolean{
    let res = false;
    if(datas.length <= this.limit.value){
      this.dataObs.next(datas);
      this.countObs.next(datas.length);
      res = true;
    }
    //
    let valueFull= false;
    if(datas.length < this.limit.value){
      valueFull = false;
    } else {
      valueFull = true;
    }
    if(this.fullObs.value != valueFull){
      this.fullObs.next(valueFull);
    }
    return res;
  }

  getData(): DataCompare[]{
    return this.dataObs.value;
  }
}


